import { render, staticRenderFns } from "./MultiAlbumCover.vue?vue&type=template&id=38093b25&scoped=true&"
import script from "./MultiAlbumCover.vue?vue&type=script&lang=js&"
export * from "./MultiAlbumCover.vue?vue&type=script&lang=js&"
import style0 from "./MultiAlbumCover.vue?vue&type=style&index=0&id=38093b25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38093b25",
  null
  
)

export default component.exports